import axios from 'axios'
import { handleError } from '../../../util'
import moment from 'moment/moment'

const AVAILABILITY_TYPE = 1;
const APPOINTMENT_TYPE = 2;
const AVAILABILITY_CUSTOM_TYPE = 3;
const limitSizePerPage = 100;

const config = {
    headers: {
        "Content-Type": "application/vnd.api+json",
    },
};

export default {
    updateUserTimezone({ commit }, { userId, timezone, oldTimezone }) {
        const data = {
            data: {
                type: "users",
                id: userId,
                attributes: {
                    time_zone: timezone,
                },
            },
        };

        axios
        .patch(`/api/v2/users/${userId}`, data, config)
        .then(() => {
            console.log("Update user timezone successful");
            commit("setUserTimezone", timezone);
        })
        .catch(err => {
            commit("setUserTimezone", oldTimezone);
            handleError(err, "Axios: updateUserTimezone");
        });
    },
    getEvent(ctx, { eventId }) {
        axios
        .get(`/api/v2/events/${eventId}`)
        .then(response => {
            commit("setEvent", response.data);
        })
        .catch(err => handleError(err, "Axios: getEvent"));
    },
    getEvents({ commit }, { id, zone, expertName, projectTitle }) {
        axios
        .get(`/api/v2/assignments/${id}/events?page[size]=${limitSizePerPage}&include=assignment.project&sort=+start`)
        .then(response => {
            if (response.data.data.length > 0) {
                const data = response.data.data;
                const dataLength = data.length;
                let events = [];
                let eventSlots = []
                let customEventSlots = []
                let appointments = []
                let project = null;

                response.data.included.map(item => {
                    if (item.type === "projects") {
                        project = item.attributes;
                        project["id"] = item.id;
                    }
                });

                for (let i = 0; i < dataLength; i++) {
                    events[i] = data[i]["attributes"];
                    events[i].id = data[i]["id"];
                    events[i].isMidnight = false;

                    const eventStart = events[i].start, eventEnd = events[i].end
                    const startUtc = moment.utc(eventStart);
                    const endUtc = moment.utc(eventEnd);
                    const createdUtc = moment.utc(events[i].created_at).format();
                    const updatedUtc = moment.utc(events[i].updated_at).format();

                    if (project != null) {
                        events[i].project = project;
                    }
                    if (events[i].eventType.name === "appointment") {
                        events[i]["name"] = "Nodes Meeting: " + projectTitle + " (" + expertName + ")";
                        events[i]["color"]["name"] = "primary";

                        appointments.push(startUtc.valueOf())
                    } else if (events[i].eventType.name === "availability") {
                        events[i]["name"] = "Available: " + expertName;
                        events[i]["color"]["name"] = "yellow";
                    }



                    const startZone = moment(startUtc.format())
                    .tz(zone)
                    .format("YYYY-MM-DD HH:mm");
                    let endZone = moment(endUtc.format())
                    .tz(zone)
                    .format("YYYY-MM-DD HH:mm");
                    const endZoneTime = moment(endUtc.format())
                    .tz(zone)
                    .format("HH:mm:ss");
                    if (endZoneTime === "00:00:00") {
                        events[i].isMidnight = true;
                        endZone = moment(endUtc.format())
                        .tz(zone)
                        .subtract(1, "minute")
                        .format("YYYY-MM-DD HH:mm");
                    }
                    const createdZone = moment(createdUtc)
                    .tz(zone)
                    .format("YYYY-MM-DD HH:mm");
                    const updatedZone = moment(updatedUtc)
                    .tz(zone)
                    .format("YYYY-MM-DD HH:mm");

                    events[i].start = moment(startZone).valueOf();
                    events[i].startUTC = startUtc.valueOf();
                    events[i].end = moment(endZone).valueOf();
                    events[i].endUTC = endUtc.valueOf();
                    events[i].created_at = moment(createdZone).valueOf();
                    events[i].updated_at = moment(updatedZone).valueOf();
                    events[i].created_by_name = null;
                    events[i].updated_by_name = null;
                    if (events[i].created_by.first_name !== undefined && events[i].created_by.last_name !== undefined) {
                        events[i].created_by_name = events[i].created_by.first_name + " " + events[i].created_by.last_name;
                    }
                    if (events[i].updated_by.first_name !== undefined && events[i].updated_by.last_name !== undefined) {
                        events[i].updated_by_name = events[i].updated_by.first_name + " " + events[i].updated_by.last_name;
                    }

                    events[i]["timed"] = true;

                    //new timeslots
                    const isAfterNow = startUtc.isAfter(moment.utc(), 'hour')
                    if(isAfterNow && 'availability' === events[i].eventType.name) {
                        eventSlots.push(startUtc.valueOf())
                    }

                    //custom slots
                    if(events[i].eventType.name === "available_custom" && isAfterNow) {
                        customEventSlots.push({id: events[i].id, start: startUtc.valueOf(), end: endUtc.valueOf(), type: events[i].type_id})
                    }
                }

                commit("setEvents", events);
                commit("updateSlots", eventSlots);
                commit("updateCustomSlots", customEventSlots);
                commit("updateAppointments", appointments);
            }
        })
        .catch(err => handleError(err));
    },
    getTimeZones({ commit }) {
        axios
        .get("/api/v2/timeZones")
        .then(res => {
            const data = res.data.data;
            let timeZones = [];
            data.map(item => {
                const offset = item["attributes"]["offset"];
                const zone = item["attributes"]["zone"];
                const content = [zone, "(" + offset + ") " + zone];
                timeZones.push(content);
            });
            commit("setTimeZones", timeZones);
        })
        .catch(err => handleError(err, "Axios: getTimeZones"));
    },
    createEvent({ commit }, { availability, zone }) {
        const templateId = availability.templateId;
        if (availability.start == null || availability.end == null) {
            commit("deleteEventTemplate", templateId);
            return false;
        }

        const startLocal = moment(availability.start).format();
        const endLocal = moment(availability.end).format();
        const startTz = moment(startLocal)
        .tz(zone, true)
        .format();
        let endTz = moment(endLocal)
        .tz(zone, true)
        .format();
        if (availability.isMidnight && moment(availability.end).format("hh:mm A") == "11:59 PM") {
            endTz = moment(endLocal)
            .tz(zone, true)
            .add(1, "minute")
            .format();
        }
        const startUtc = moment(startTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");
        const endUtc = moment(endTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");

        if (startUtc == "Invalid date" || endUtc == "Invalid date") {
            commit("deleteEventTemplate", templateId);
            return false;
        }

        const data = {
            data: {
                type: "events",
                attributes: {
                    start: startUtc,
                    end: endUtc,
                    name: availability.name,
                    assignment_id: parseInt(availability.assignmentId),
                    type_id: AVAILABILITY_TYPE,
                    color_id: 1,
                },
            },
        };

        axios
        .post(`/api/v2/events`, data, config)
        .then(response => {
            let event = response.data.data.attributes;
            event.id = response.data.data.id;
            const createdUtc = moment.utc(event.created_at).format();
            const updatedUtc = moment.utc(event.updated_at).format();
            const createdZone = moment(createdUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            const updatedZone = moment(updatedUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            const startUtc = moment.utc(event.start).format();
            const endUtc = moment.utc(event.end).format();
            const startZone = moment(startUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            let endZone = moment(endUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            let isMidnight = false;
            if (
                moment(endUtc)
                .tz(zone)
                .format("HH:mm:ss") == "00:00:00"
            ) {
                isMidnight = true;
                endZone = moment(endUtc)
                .tz(zone)
                .subtract(1, "minute")
                .format("YYYY-MM-DD HH:mm");
            }

            event.start = moment(startZone).valueOf();
            event.end = moment(endZone).valueOf();
            event.isMidnight = isMidnight;
            event.created_at = moment(createdZone).valueOf();
            event.updated_at = moment(updatedZone).valueOf();
            event["timed"] = true;
            event["color"]["name"] = "yellow";
            commit("updateEventTemplate", { templateId, data: event });
        })
        .catch(err => {
            commit("deleteEventTemplate", templateId);
            if (err.response && err.response.status === 409) {
                const msg = err.response.data?.errors?.[0]?.title
                    || 'This time slot overlaps with an existing event.';
                commit("setOverlapError", msg);
                return;
            }
            handleError(err, "Axios: createEvent");
        });
    },
    newCreateEvent({ commit }, { availability, zone }) {
        const startLocal = moment(availability.start).format('LLL Z');
        const endLocal = moment(availability.end).format('LLL Z');

        const startTz = moment(startLocal)
        .tz(zone)
        .format('LLL Z');
        let endTz = moment(endLocal)
        .tz(zone)
        .format('LLL Z');

        if (availability.isMidnight && moment(availability.end).format("hh:mm A") === "11:59 PM") {
            endTz = moment(endLocal)
            .tz(zone)
            .add(1, "minute")
            .format();
        }
        const startUtc = moment(startTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");

        const endUtc = moment(endTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");

        if (startUtc === "Invalid date" || endUtc === "Invalid date") {
            return false;
        }
        const data = {
            data: {
                type: "events",
                attributes: {
                    start: startUtc,
                    end: endUtc,
                    name: availability.name,
                    type_id: availability.type,
                    assignment_id: parseInt(availability.assignmentId),
                    // type_id: AVAILABILITY_TYPE,
                    color_id: 1,
                },
            },
        };

        axios
        .post(`/api/v2/events`, data, config)
        .then(response => {
            let event = response.data.data.attributes;
        })
        .catch(err => {
            handleError(err, "Axios: createEvent");
        });
    },
    updateEvent({ dispatch, commit }, { availability, zone, oldEvent, expertName, projectTitle }) {
        if (availability.id == undefined) {
            return false;
        }

        const startTz = moment(availability.start)
        .tz(zone, true)
        .format();
        let endTz = moment(availability.end)
        .tz(zone, true)
        .format();
        if (
            moment(availability.end)
            .tz(zone, true)
            .format("hh:mm A") == "11:59 PM"
        ) {
            endTz = moment(availability.end)
            .tz(zone, true)
            .add(1, "minute")
            .format();
        }
        let startUtc = moment(startTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");
        let endUtc = moment(endTz)
        .utc()
        .format("YYYY-MM-DD HH:mm");

        if (availability.startTime) {
            const startTimezone = moment(availability.startTime)
            .tz(zone, true)
            .format();
            let endTimezone = moment(availability.endTime)
            .tz(zone, true)
            .format();
            if (
                availability.isMidnight &&
                moment(availability.endTime)
                .tz(zone, true)
                .format("hh:mm A") == "11:59 PM"
            ) {
                endTimezone = moment(availability.endTime)
                .tz(zone, true)
                .add(1, "minute")
                .format();
            }
            startUtc = moment(startTimezone)
            .utc()
            .format("YYYY-MM-DD HH:mm");
            endUtc = moment(endTimezone)
            .utc()
            .format("YYYY-MM-DD HH:mm");
        }

        const data = {
            data: {
                type: "events",
                id: availability.id,
                attributes: {
                    start: startUtc,
                    end: endUtc,
                    assignment_id: parseInt(availability.assignmentId),
                },
            },
        };

        axios
        .patch(`/api/v2/events/${availability.id}?include=assignment.project`, data, config)
        .then(response => {
            const data = response.data.data.attributes;
            let isMidnight = false;
            let dataUpdate = { color: data.color };
            const startUtc = moment.utc(data.start).format();
            const endUtc = moment.utc(data.end).format();
            const startZone = moment(startUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            let endZone = moment(endUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            if (
                moment(endUtc)
                .tz(zone)
                .format("hh:mm A") == "12:00 AM"
            ) {
                isMidnight = true;
                endZone = moment(endUtc)
                .tz(zone)
                .subtract(1, "minute")
                .format("YYYY-MM-DD HH:mm");
            }

            const start = moment(startZone).valueOf();
            const end = moment(endZone).valueOf();

            if (data.type_id == APPOINTMENT_TYPE) {
                dataUpdate["name"] = "Nodes Meeting: " + projectTitle + " (" + expertName + ")";
                dataUpdate["color"]["name"] = "primary";
            } else if (data.type_id == AVAILABILITY_TYPE) {
                dataUpdate["name"] = "Available: " + expertName;
                dataUpdate["color"]["name"] = "yellow";
            }
            dataUpdate["start"] = start;
            dataUpdate["end"] = end;
            dataUpdate["isMidnight"] = isMidnight;
            dataUpdate.created_by_name = null;
            dataUpdate.updated_by_name = null;
            if (data.created_by.first_name != undefined && data.created_by.last_name != undefined) {
                dataUpdate.created_by_name = data.created_by.first_name + " " + data.created_by.last_name;
            }
            if (data.updated_by.first_name != undefined && data.updated_by.last_name != undefined) {
                dataUpdate.updated_by_name = data.updated_by.first_name + " " + data.updated_by.last_name;
            }

            dataUpdate["timed"] = true;
            dataUpdate["type_id"] = data.type_id;

            commit("updateAppointment", { event: availability, data: dataUpdate });
            if (availability.type_id == APPOINTMENT_TYPE) {
                if (data.hasOwnProperty("meeting")) {
                    const meeting_id = data.meeting.id;
                    const eventData = {
                        event_id: parseInt(response.data.data.id),
                        start: data.start,
                        end: data.end,
                    };
                    dispatch("updateMeeting", { meeting_id, eventData });
                } else {
                    let project = null;
                    response.data.included.map(item => {
                        if (item.type == "projects") {
                            project = item.attributes;
                            project["id"] = item.id;
                        }
                    });
                    const eventData = {
                        event_id: parseInt(response.data.data.id),
                        start: data.start,
                        end: data.end,
                        project,
                    };
                    dispatch("createMeeting", eventData);
                }
            }
            commit("updateEvent", availability);
        })
        .catch(err => {
            commit("updateEventStartEnd", {
                start: oldEvent.start,
                end: oldEvent.end,
                isMidnight: oldEvent.isMidnight,
                event: availability,
            });
            if (err.response && err.response.status === 409) {
                const msg = err.response.data?.errors?.[0]?.title
                    || 'This time slot overlaps with an existing event.';
                commit("setOverlapError", msg);
                return;
            }
            handleError(err, "Axios: updateEvent");
        });
    },
     deleteEvent({ dispatch, commit }, { eventId, meetingId }) {
        if (meetingId != null) {
            dispatch("deleteMeeting", meetingId).then(() => {
                axios
                    .delete(`/api/v2/events/${eventId}`)
                    .then(() => {
                        commit("deleteEvent", eventId);
                    })
                    .catch(err => {
                        handleError(err, "Axios: deleteEvent");
                        if (err.response && err.response.status === 404) {
                            commit("setDeleteError", "Event not found. It may have already been deleted.");
                        }
                    });
            });
        } else {
            axios
                .delete(`/api/v2/events/${eventId}`)
                .then(() => {
                    commit("deleteEvent", eventId);
                })
                .catch(err => {
                    handleError(err, "Axios: deleteEvent");
                    if (err.response && err.response.status === 404) {
                        commit("setDeleteError", "Event not found. It may have already been deleted.");
                    }
                });
        }
    },
    deleteEventByStart({dispatch, commit}, {startTime, endTime,type, assignmentId, zone, expertName, projectTitle}){
        axios
        .delete(`/admin/assignment/event-by-start/?start=${startTime}&end=${endTime}&type=${type}&assignment_id=${assignmentId}`)
        .then(() => {
            dispatch("getEvents", {
                id: assignmentId,
                zone: zone,
                expertName: expertName,
                projectTitle: projectTitle,
            });
        })
        .catch(err => handleError(err, "Axios: deleteEvent"));
    },
    changeEventType({ dispatch, commit }, { appointment, expertName, zone, projectTitle }) {
        const data = {
            data: {
                type: "events",
                id: appointment.id,
                attributes: {
                    type_id: APPOINTMENT_TYPE,
                },
            },
        };

        axios
        .patch(`/api/v2/events/${appointment.id}?include=assignment.project`, data, config)
        .then(response => {
            let data = response.data.data.attributes;
            let project = null;
            response.data.included.map(item => {
                if (item.type == "projects") {
                    project = item.attributes;
                    project["id"] = item.id;
                }
            });
            const createdUtc = moment.utc(data.created_at).format();
            const updatedUtc = moment.utc(data.updated_at).format();
            const createdZone = moment(createdUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");
            const updatedZone = moment(updatedUtc)
            .tz(zone)
            .format("YYYY-MM-DD HH:mm");

            let appointmentObj = {};
            appointmentObj["name"] = "Nodes Meeting: " + projectTitle + " (" + expertName + ")";
            appointmentObj["color"] = "primary";
            appointmentObj["created_at"] = moment(createdZone).valueOf();
            appointmentObj["updated_at"] = moment(updatedZone).valueOf();
            appointmentObj["created_by_name"] = null;
            appointmentObj["updated_by_name"] = null;
            appointmentObj["type_id"] = data.type_id;
            if (project != null) {
                appointmentObj["project"] = project;
            }

            if (data.created_by.first_name != undefined && data.created_by.last_name != undefined) {
                appointmentObj["created_by_name"] = data.created_by.first_name + " " + data.created_by.last_name;
            }
            if (data.updated_by.first_name != undefined && data.updated_by.last_name != undefined) {
                appointmentObj["created_by_name"] = data.updated_by.first_name + " " + data.updated_by.last_name;
            }

            if (!response.data.data.attributes.hasOwnProperty("meeting")) {
                const eventData = {
                    event_id: parseInt(response.data.data.id),
                    start: response.data.data.attributes.start,
                    end: response.data.data.attributes.end,
                    project,
                };
                dispatch("createMeeting", eventData);
            }

            commit("updateAppointment", { event: appointment, data: appointmentObj });
        })
        .catch(err => handleError(err, "Axios: changeEventType"));
    },
    createMeeting({ commit }, eventData) {
        const event_id = eventData.event_id;
        const project = eventData.project;
        const topic = "Nodes Meeting: " + project.project_title;
        const start_time = moment(eventData.start);
        const end_time = moment(eventData.end);
        const detail = project.project_title;
        const data = {
            data: {
                type: "meetings",
                attributes: {
                    event_id: event_id,
                    subject: topic,
                    body: detail,
                    start_time: start_time.format("YYYY-MM-DD HH:mm"),
                    end_time: end_time.format("YYYY-MM-DD HH:mm"),
                    timezone: "UTC",
                },
            },
        };

        axios
        .post(`/api/v2/meetings`, data, config)
        .then(response => {
            let meeting = response.data.data.attributes;
            meeting.id = response.data.data.id;
            commit("updateMeetingToEvent", { event_id, meeting });
        })
        .catch(err => handleError(err, "Axios: createMeeting"));
    },
    updateMeeting({ commit }, { meeting_id, eventData }) {
        const event_id = eventData.event_id;
        const start_time = moment(eventData.start);
        const end_time = moment(eventData.end);
        const data = {
            data: {
                type: "meetings",
                id: parseInt(meeting_id).toString(),
                attributes: {
                    start_time: start_time.format("YYYY-MM-DD HH:mm"),
                    end_time: end_time.format("YYYY-MM-DD HH:mm"),
                },
            },
        };
        axios
        .patch(`/api/v2/meetings/${meeting_id}`, data, config)
        .then(response => {
            let meeting = response.data.data.attributes;
            meeting.id = response.data.data.id;
            commit("updateMeetingToEvent", { event_id, meeting });
        })
        .catch(err => handleError(err, "Axios: updateMeeting"));
    },
    deleteMeeting({ commit }, meetingId) {
        axios
        .delete(`/api/v2/meetings/${meetingId}`, config)
        .then()
        .catch(err => handleError(err, "Axios: deleteMeeting"));
    },
    popEvent({ commit }) {
        commit("popEvent");
    },
    setEventTemplate({ commit }, event) {
        commit("setEventTemplate", event);
    },
    mouseMove({ commit }, { ele, tms }) {
        const mouse = ele.toTime(tms);

        // If currently moving the entire event card.
        if (ele.dragEvent && ele.dragTime !== null) {
            const start = ele.dragEvent.start;
            const end = ele.dragEvent.end;
            const duration = end - start;
            const newStartTime = mouse - ele.dragTime;
            const newStart = ele.roundTime(newStartTime);
            let newEnd = newStart + duration;
            let isMidnight = false;
            if (moment(newEnd).format("hh:mm A") == "12:00 AM") {
                newEnd = moment(newEnd)
                .subtract(1, "minute")
                .valueOf();
                isMidnight = true;
            }
            commit("updateEventStartEnd", { start: newStart, end: newEnd, isMidnight, event: ele.dragEvent });

            // If currently creating a new event.
        } else if (ele.createEvent && ele.createStart !== null) {
            const mouseRounded = ele.roundTime(mouse, false);
            const min = Math.min(mouseRounded, ele.createStart);
            let max = Math.max(mouseRounded, ele.createStart);
            let isMidnight = false;
            if (moment(max).format("hh:mm A") == "12:00 AM") {
                max = moment(max)
                .subtract(1, "minute")
                .valueOf();
                isMidnight = true;
            }
            ele.availability.end = max;
            ele.availability.isMidnight = isMidnight;
            commit("updateEventStartEnd", { start: min, end: max, isMidnight, event: ele.createEvent });
        }
    },
    resetEventStartEnd({ commit }, { start, end, event }) {
        commit("updateEventStartEnd", { start, end, isMidnight: null, event });
    },
    deleteEventByIndex({ commit }, index) {
        commit("deleteEventByIndex", index);
    },
}
